import Layout from "../../LayoutAdmin";
import Services from "../../../services/global.service";
import { useEffect, useState, useCallback } from "react";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { Link } from "react-router-dom";
import BreadcrumbPage from "../../../components/breadcrump";
import DeletePopup from "../../../components/admin/deletePopup";
import Datatables from "./../../../components/datatables";
import { read, utils } from 'xlsx';
import { toast } from "react-toastify";
const addCTA = (param) => {
  return (
    <div className="action">
      <Link to={`/admin/adresses/edit/${param.id}`}>
        <BorderColorIcon />
      </Link>
      <DeletePopup
        id={`${param.id}`}
        name={`${param.adresse}`}
        endpoint="adresses/delete"
      />
    </div>
  );
};

const columns = [
  {
    name: "ID",
    selector: (row) => row?.id,
    sortable: true,
    width: 10,
  },
  {
    name: "Business Unit",
    selector: (row) => row?.adresses_created_by?.bunit,
    sortable: true,
    width: 10,
  },
  {
    name: "Entité",
    selector: (row) => row?.entite,
    sortable: true,
  },
  {
    name: "Code",
    selector: (row) => row?.code,
    sortable: true,
  },
  {
    name: "Responsable",
    selector: (row) => row?.responsable,
    sortable: true,
  },
  {
    name: "Phone",
    selector: (row) => row?.phone,
    sortable: true,
  },
  {
    name: "Action",
    cell: (param) => addCTA(param),
  },
];

let rows = [];

const ListAdresses = () => {
  const [data, setdata] = useState();
  const [isReading, setIsReading] = useState(false);
  const [parsedData, setParsedData] = useState([]);
  const handleSave=()=>{
    console.log('save',parsedData)
    Services.create({data:parsedData},'adresses/import')
    .then((res)=>{
      toast.success('Fichier importé !', {
        position: 'top-right',
        autoClose: 3000, // Close the toast after 3000 milliseconds (3 seconds)
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setTimeout(() => {
        // Uncomment the line below if needed
         window.location.reload();
      }, 3000); // Reload after 5 seconds
    })
    .catch((err)=>{
      toast.error('Erreur lors de l importation !!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    })
  }
  const handleFileChange = useCallback(e => {
    const file = e.target.files[0];
    var reader = new FileReader();
    reader.onload = function(e) {
      var data = new Uint8Array(e.target.result);
      var workbook = read(data, { type: "array" });
      var firstSheet = workbook.SheetNames[0];
      setIsReading(false);
      const elements = utils.sheet_to_json(workbook.Sheets[firstSheet]);
      console.log("Excel read OK!");
      console.log("Found " + elements.length + " elements");
      console.log("JSON ", JSON.stringify(elements));
      console.log("JSON size", JSON.stringify(elements).length, "bytes");
      setParsedData(elements)
    };
    setIsReading(true);
    reader.readAsArrayBuffer(file);
  }, []);
  useEffect(() => {
    Services.getAll("adresses/list").then(
      (response) => {
        if (response.data.adresses) {
          setdata(response.data.adresses);
          response.data.adresses.forEach((element) => {
            rows = response.data.adresses;
          });
        }
        console.log( 'datatable',response.data);        // navigate("/catalogue");
      },
      (error) => {}
    );
  }, []);

  return (
    <Layout>
      <div className="container min-vh-80">
        <BreadcrumbPage parent="Adresses" page="Liste des adresses" sub="" />

        <div className="row">
          <div className="col-md-6">
            <h1>Liste des Adresses</h1>
          </div>
          <div className="col-md-6 right-aj">
            <a className="btn-primary" href="/admin/adresses/add">
              Ajouter
            </a>
          </div>
        </div>
        <div className="my-2 text-end">
            {/* File Uploader */}
            <input type="file" accept=".xls, .xlsx" onChange={handleFileChange} /> 
            <button className="btn-primary" onClick={handleSave}>Importer</button>
              {isReading ? <p>Reading...</p> : null}
          </div>
        <div className="row">
          <div className="col-md-12" style={{ width: "100%" }}>
            <Datatables columns={columns} data={rows} />
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default ListAdresses;
